import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import Logo from "../../assets/img/logo.png";
import EyeBlock from "../../assets/img/eye_block.svg";
import EyeOpen from "../../assets/img/eye_open.svg";
import CheckboxIcon from "../../assets/img/check-icon.svg";
import Checkbox from "react-custom-checkbox";
import { Success } from "../../components/Alert";
import api from "../../config/api";
import { getCategories, getCepCoordinates } from "../../config/utils";
import Spinner from "react-bootstrap/Spinner";
import { MenuItem, TextField } from "@material-ui/core";
import TextPhoneMask from "./Mask/TextPhoneMask";
import CepMask from "./Mask/CepMask";
import swal from "sweetalert";
// import LoginImg from "../../../assets/img/login.svg";

function CreateAccount() {
  //

  const [telefone, setTelefone] = useState("");
  const [cep, setCep] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [storeName, setStoreName] = useState("");
  const [business, setBusiness] = useState("");
  const [regexPassword, setRegexPassword] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // TODO: Add remember user logic
  const [rememberMe, setRememberMe] = useState(false);
  const [selectInput, setSelectInput] = useState("Selecione o tipo do seu negócio");
  const passwordMismatchError = "Senhas não conferem";
  const regexPasswordError =
    "As senhas devem ter no mínimo 8 caracteres contendo uma letra, um número e um caracter especial";
  const [error, setError] = useState("");
  const [isSuccessModalActive, setIsSuccessModalActive] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);
  const [listCategory, setListCategory] = useState([]);
  const [user, setUser] = useState({});
  const handleChange = (event) => {
    setUser((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };
  const handleCategoryChange = (category) => {
    setUser((user) => ({
      ...user,
      category: category.id,
    }));
    setSelectInput(category.name);
  };

  useEffect(() => {
    get();
  }, []);

  function validarSenha(event) {
    const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={[}\]|\\:;"'<,>.?/-]).{8,}$/;
    let pw = regex.test(event.target.value);
    setRegexPassword(pw);
    if (pw) {
      handleChange(event);
    }
  }

  useEffect(() => {
    if (user.password === user.confirmPassword && error === passwordMismatchError) {
      setError("");
    }
  }, [error, user]);

  const get = async () => {
    const categories = await getCategories();
    // console.log(categories);
    setListCategory(categories);
  };

  const show = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const showConfirm = (e) => {
    e.preventDefault();
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleCreateAccountSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoadBtn(true);

    if (!regexPassword) {
      setError(regexPasswordError);
      setLoadBtn(false);
      return;
    }

    if (user.password !== user.confirmPassword) {
      setError(passwordMismatchError);
      setLoadBtn(false);
      return;
    } else {
      const { confirmPassword, cep, ...formattedUser } = user;
      const { lat, long, error: cepError } = await getCepCoordinates(cep);
      if (cepError) {
        setError(cepError);
        setLoadBtn(false);
        return;
      }

      const data = { cep: cep, longitude: long, latitude: lat, ...formattedUser };
      await api.post("/establishment", data).then((res) => {
        if (res.data.success) {
          swal(
            "Seu estabelecimento foi cadastrado com sucesso!",
            "Por favor aguarde que o administrador do sistema ira verificar seus dados e ativar sua empresa",
            "success"
          );
          setIsSuccessModalActive(true);
          setTimeout(() => {
            document.location.href = "/";
          }, 5000);
          setLoadBtn(false);
        } else if (res.data.error) {
          setError(res.data.message);
          setLoadBtn(false);
        }
      });
    }
    setLoadBtn(false);
  };

  return (
    <>
      <div className="container-fluid mb-5 mb-lg-0  h-100">
        <div className="row h-100">
          <div className="bg-img-login col-lg-7 d-flex justify-content-start align-items-end ">
            <div className="row m-0">
              <h1 className="title mb-3 text-white fz-34 ff-univanova-300">
                Bem-vindo ao <br />
                <span className="ff-univanova-bold">RESERVEI</span>
              </h1>
              {/* <h2 className="subtitle mb-4 text-white fz-16 ff-univanova-300">
                Lorem ipsum dolor sit amet, consetetur
              </h2> */}
            </div>
          </div>
          <div className="col-lg-5 mt-5 my-lg-auto">
            <form className="px-3 mb-5 mb-lg-0" onSubmit={handleCreateAccountSubmit}>
              <div className="d-flex justify-content-center align-items-center mb-5">
                <img alt="" src={Logo} />
              </div>
              <div className="mb-4">
                <h2 className="d-flex justify-content-center ff-univanova-600 fz-24 text-cl-cyan">Solicitar acesso</h2>
              </div>
              <div className="mb-2">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">Tipo de negócio</h2>
                <TextField
                  required
                  select
                  placeholder="Digite o nome da sua empresa"
                  variant={"standard"}
                  name="category"
                  onChange={(event) => {
                    handleCategoryChange(JSON.parse(event.target.value));
                    setBusiness(event.target.value);
                  }}
                  value={business}
                  className="input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 my-2 "
                >
                  {listCategory.map((category) => (
                    <MenuItem
                      key={category._id}
                      value={JSON.stringify({
                        name: category.name,
                        id: category._id,
                      })}
                    >
                      {category.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="mb-2">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">Nome da empresa</h2>
                <TextField
                  required
                  placeholder="Digite o nome da sua empresa"
                  variant={"standard"}
                  name="storeName"
                  onChange={(event) => {
                    handleChange(event);
                    setStoreName(event.target.value);
                  }}
                  value={storeName}
                  className="input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 mt-2"
                />
              </div>
              <div className="mb-2">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">CEP da empresa</h2>
                <TextField
                  required
                  placeholder="Digite o CEP da sua empresa"
                  variant={"standard"}
                  name="cep"
                  InputProps={{
                    inputComponent: CepMask,
                  }}
                  onChange={(event) => {
                    handleChange(event);
                    setCep(event.target.value);
                  }}
                  value={cep}
                  className="input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 mt-2"
                />
              </div>
              <div className="mb-2">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">Celular</h2>
                <TextField
                  required
                  placeholder="Digite o telefone da sua empresa"
                  variant={"standard"}
                  name={"phone"}
                  InputProps={{
                    inputComponent: TextPhoneMask,
                  }}
                  onChange={(event) => {
                    handleChange(event);
                    setTelefone(event.target.value);
                  }}
                  value={telefone}
                  className="input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 mt-2"
                />
              </div>
              <div className="mb-2">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">E-mail</h2>
                <TextField
                  required
                  placeholder="Escreva seu e-mail"
                  type={"email"}
                  variant={"standard"}
                  name={"email"}
                  onChange={(event) => {
                    handleChange(event);
                    setEmail(event.target.value);
                  }}
                  value={email}
                  className="input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 mt-2"
                />
              </div>
              <div className="">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">Senha</h2>
                <div className="eye-component d-flex">
                  <TextField
                    required
                    placeholder="Digite sua senha"
                    variant={"standard"}
                    name={"password"}
                    type={showPassword ? "text" : "password"}
                    onChange={(event) => {
                      setPassword(event.target.value);
                      validarSenha(event);
                      // handleChange(event);
                    }}
                    value={password}
                    className="input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 mt-2"
                  />
                  <button onClick={(event) => show(event)} className="border-0 bg-transparent">
                    <img
                      alt=""
                      width={"24px"}
                      height={"24px"}
                      className=" w-auto"
                      src={showPassword ? EyeOpen : EyeBlock}
                    />
                  </button>
                </div>
              </div>
              <div className="mb-2">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan mt-2">Repetir Senha</h2>
                <div className="eye-component d-flex">
                  <TextField
                    required
                    placeholder="Digite sua senha novamente"
                    variant={"standard"}
                    name={"confirmPassword"}
                    type={showConfirmPassword ? "text" : "password"}
                    onChange={(event) => {
                      handleChange(event);
                      setConfirmPassword(event.target.value);
                    }}
                    value={confirmPassword}
                    className="input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 my-2"
                  />
                  <button onClick={(event) => showConfirm(event)} className="border-0 bg-transparent">
                    <img
                      alt=""
                      width={"24px"}
                      height={"24px"}
                      className=" w-auto"
                      src={showConfirmPassword ? EyeOpen : EyeBlock}
                    />
                  </button>
                </div>
              </div>
              <div style={{ marginBottom: "24px" }}>
                <button
                  type="submit"
                  className="w-100 btn bg-gradient-cyan-blue text-white font-poppins py-2 fz-18 d-flex justify-content-center ff-univanova-medium"
                >
                  {loadBtn ? (
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : (
                    "Solicitar"
                  )}
                </button>
                <h3 className="mt-2 text-cl-red fz-12 ff-univanova-regular errorMessage">{error}</h3>
              </div>
              <div className="d-flex align-items-center justify-content-between check-box">
                <Checkbox
                  icon={<img style={{ width: "20px", height: "20px" }} alt="" src={CheckboxIcon} />}
                  name="my-input"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                  borderColor="#6D777D"
                  style={{ cursor: "pointer", width: "24px", height: "24px" }}
                  labelStyle={{
                    marginLeft: 8,
                    userSelect: "none",
                    color: "#6D777D",
                    fontSize: "14px",
                  }}
                  label="Lembrar de mim"
                />
                <div className="d-flex align-items-center">
                  <span className="text-cl-auroMetal fz-14 ff-univanova">Já tem conta?</span>
                  <div className={`d-flex justify-content-end ms-3`}>
                    <a href="/" className="btn btn-white button-white-primary fz-16 px-4 ff-univanova-medium">
                      Fazer login
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {isSuccessModalActive && (
        <Success
          id="CreateAccount"
          title={"Seu registro foi efetuado com sucesso!"}
          // TODO: Update description && redirect to login after closing registration modal
          description="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero."
        />
      )}
    </>
  );
}

export default CreateAccount;
